module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="add-accessorie-vue-container"><fieldset><legend>'+
((__t=( i18n.tc( "ControlAccessories", "Add new accessory" ) ))==null?'':__t)+
'</legend></fieldset><fieldset><div><label for="search-serial-input">'+
((__t=( i18n.tc( "ControlAccessories", "Serial number:" ) ))==null?'':__t)+
'</label> <input type="text" id="search-serial-input" v-model="inputValue"></div><dl v-show="submitError"><dd><p class="error">ERROR! {{ submitError }}</p></dd></dl></fieldset><fieldset class="button-wrap"><button @click="onClickClose">'+
((__t=(i18n.tc('ControlAccessories', 'Close')))==null?'':__t)+
'</button> <button class="primary" @click="save()" :disabled="disableFormSubmit">'+
((__t=( i18n.tc( "ControlAccessories", "Add" ) ))==null?'':__t)+
'</button></fieldset><div><p><em><small>'+
((__t=(i18n.tc('ControlAccessories', 'Add new accessories here by entering the serial number for the accessory. When entering a serial number for a DEFA Home product, please use only the last 5 digits. When entering a serial number for Nobø product, please enter all characters.')))==null?'':__t)+
' </small></em></p></div></div>';
}
return __p;
};
